export default __webpack_public_path__ + "static/media/bell.86c1d5f8.svg";